import { FC, useEffect, useRef } from "react";
import { useMsal } from "@azure/msal-react";
import { Session } from "@/utils";
import { useNavigate } from "react-router-dom";

interface IProps {
  sidebarOpen: boolean;
  setSidebarOpen: (arg0: boolean) => void;
}

const Burger: FC<IProps> = ({ sidebarOpen, setSidebarOpen }) => {
  const { instance } = useMsal();
  const menuRef = useRef<HTMLDivElement>(null);
  const navigate = useNavigate();

  const handleLogout = () => {
    if(Session.getUserType() === 'poa'){
      instance.logoutRedirect({
          postLogoutRedirectUri: "/",
      });
      Session.abandon();
    }else{
      Session.abandon();
      navigate('/home');
    }

  };

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (menuRef.current && !menuRef.current.contains(event.target as Node)) {
        setSidebarOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [setSidebarOpen]);

  return (
    <div className={`burger ${sidebarOpen ? 'burger--open' : ''}`} ref={menuRef}>
      <button
        className="burger__button"
        onClick={() => setSidebarOpen(!sidebarOpen)}
        aria-expanded={sidebarOpen}
        aria-label="Toggle menu"
      >
        <span className="burger__line"></span>
        <span className="burger__line"></span>
        <span className="burger__line"></span>
      </button>

      {sidebarOpen && (
        <ul className="burger__menu">
          <li className="burger__item" onClick={handleLogout}>Log Out</li>
        </ul>
      )}
    </div>
  );
};

export default Burger;